import type React from "react"
import type ShowArticleDeliveryArticlesProperties from "./ShowArticleDeliveryArticlesProperties"
import { useStyles } from "./ShowArticleDeliveryArticles.style"
import { CurrencyModule } from "../../../util/Currency"
import { useI18nContext } from "../../../contexts/I18nContext"
import clsx from "clsx"
import Currency from "../../../entities/Currency"

const ShowArticleDeliveryArticles: React.FC<ShowArticleDeliveryArticlesProperties> = ({
  valueToPay,
  articles,
  className = "",
}) => {
  const i18n = useI18nContext()
  const classes = useStyles()

  return (
    <div className={clsx(classes.show_price_container, className)}>
      <div>
        <div className={classes.number}>
          <div className={classes.title}>{`${i18n.translate("TOTAL_TO_PAY")}:`}</div>
          <div className={classes.value}>{valueToPay && CurrencyModule.format(valueToPay, Currency.DOLLAR)}</div>
        </div>
        <div className={classes.currency}>USD</div>
      </div>
      <div>
        <div className={classes.title} style={{ marginTop: "12px" }}>{`Artículos (${articles.length}):`}</div>
        <div className={classes.articles_container}>
          {articles.map((article, index) => (
            <div key={index} className={classes.article_item_wrapper}>
              <div className={classes.article_item}>
                <span className={classes.article_name}>{article.articleName}</span>
                <span className={clsx(classes.article_badge, classes.quantity_badge)}>Qty: {article.amount}</span>
                <span className={clsx(classes.article_badge, classes.delivery_badge)}>
                  {article.deliveryTimeDays ?? '-'} {article.deliveryTimeDays === 1 ? "día" : "días"}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ShowArticleDeliveryArticles
